const locales = {
  "ja": {
    "main_title": "<span class=\"text-plan_brand\">旅行</span>プランニングサービス",
    "main_description": "おすすめの観光スポットやお店を選ぶだけで簡単に旅行プランがつくれちゃう！<br />目的地を追加・削除すると、自動で移動方法も再検索されるので、計画の変更もとっても簡単。",
    "sub_description1": "2021年6月30日までご利用いただけます。",
    "sub_description2": "各施設・店舗の営業時間は、お店やその他の理由により変更になるおそれがありますので、必ずお客さまご自身でご確認ください。",
    "my_plan_section_title": "My旅行プラン",
    "model_cource_title": "モデルコースをもとにMy旅行プランをつくる",
    "display_detail_label": "詳細を表示",
    "create_plan_label": "My旅行プランを作成する",
    "category_title": "「{genreName}」から旅行プランを作成",
    "faq_label": "旅行プランニングサービスの<br />「よくあるご質問」をみる",
    "tohoku_maas_link": "HAWAII MaaSに戻る",
    "disclaimer_description1": "本サービスは、利用した結果、検索・表示される工程を保証するものではございません。",
    "disclaimer_description2": "本サービスのご利用はお客さまご自身の責任においてご利用ください。",
    "disclaimer_description3": "本サービスは、ハワイの最新情報やお得情報、ハワイで使える便利機能が備わった、ハワイ州観光局公認アプリ「HAWAIICO」と連携してご提供しています。",
    "copyright": "Copyright ©East Japan Railway Company All Rights Reserved.",
    "plan_create_title": "旅行プラン作成",
    "departure_date_condition": "出発日",
    "departure_datetime_condition": "最初の予定の開始時刻",
    "detail_conditions": "詳細設定",
    "preferred_route_condition": "優先する経路",
    "taxi_condition": "タクシー利用",
    "set_conditions_label": "この条件で設定",
    "departure_label": "出発地",
    "change_departure_label": "出発地を変更",
    "arrival_label": "到着地",
    "change_arrival_label": "到着地を変更",
    "route_label": "経路",
    "minute_label": "分",
    "hour_label": "時間",
    "residence_time_label": "滞在時間",
    "edit_label": "編集",
    "add_destination_label": "目的地を追加",
    "add_destination_from_map": "マップから追加",
    "add_destination_from_category": "カテゴリーから追加",
    "add_destination_from_favorite": "お気に入りから追加",
    "departure_time_label": "発",
    "arrival_time_label": "着",
    "normal_fare": "通常料金",
    "freepass_detail": "※対象区間が2日間乗り降り自由です",
    "other_fare": "フリーパス以外の運賃",
    "fare": "運賃",
    "freepass_merit": "フリーパス利用で{price}円お得になります",
    "freepass_link": "フリーパスの詳細はこちら",
    "save_label": "このプランを保存する",
    "back_to_plan_top_label": "プラン選択に戻る",
    "save_success": "を保存しました",
    "buy_ticket": "事前にチケットを購入したい方はこちら",
    "change_label": "編集する",
    "delete_label": "削除する",
    "cory_share_url": "共有URLをコピーする",
    "send_mail": "メールで送る",
    "send_line": "LINEで送る",
    "search_placeholder": "市内を検索",
    "seach_this_area": "このエリアを検索",
    "filter": "フィルタ",
    "genre_all": "すべてのジャンル",
    "genre": "ジャンル",
    "back": "戻る",
    "round_trip": "今から往復で◯◯分",
    "shop_information": "店舗情報",
    "docomo_share_bike": "ドコモシェアバイク",
    "tolocca": "To Locca",
    "docomo_ai_bus": "秋保オンデマンド交通",
    "times_carshare": "タイムズカーシェア",
    "location": "所在地",
    "tel": "電話番号",
    "holoday": "定休日",
    "website": "公式サイト",
    "business_hours": "営業時間",
    "nearest_station": "最寄駅",
    "search_route": "経路を検索する",
    "add_to_plan": "旅行プランに追加する",
    "locker_name": "ロッカー名",
    "amount": "金額",
    "space_availability": "満空情報",
    "by_size": "サイズ別",
    "returnable_number": "返却可能台数",
    "avaliable_number": "利用可能台数",
    "business_start_time": "営業開始時間",
    "business_end_time": "営業終了時間",
    "appearance": "外観",
    "basic_charge": "基本料金",
    "basic_usage_period": "基本利用期間",
    "extension_charge": "延長料金",
    "extension_billing_unit_time": "延長課金単位時間",
    "car_model": "車種",
    "available_number_of_people": "利用可能人数",
    "area_name": "提供エリア名",
    "max_number_of_passenger": "最大乗車人数",
    "faq": "FAQ",
    "port_name": "ポート名",
    "description": "説明",
    "about_label": "約",
    "price_with_currency_unit": "{price}<span class=\"text-sm\">円</span>",
    "require_login": "旅行プランの作成には、ログインが必要です。",
    "not_found_plan": "プランが見つかりません。URLが間違っているか、プランが削除された可能性があります",
    "course_label": "コース",
    "plan_link": "作成したプランを表示する",
    "back_to_top": "旅行プラントップへ戻る",
    "setting_departure_label": "出発地設定",
    "setting_arrival_label": "到着地設定",
    "cancel": "キャンセル",
    "change_arrival_time_and_residence_time": "開始時刻・滞在時間を変更",
    "change_arrival_time_and_departure_time": "滞在時間を変更",
    "remove_destination": "この目的地を削除",
    "map_location_error_message": "現在地情報を取得できませんでした。お使いのブラウザでは現在地情報を利用できない可能性があります。エリアを入力してください。",
    "map_permission_denied_error_message": "位置情報の利用が許可されていません",
    "map_position_unavailable_error_message": "現在位置が取得できませんでした",
    "map_timeout_error_message": "タイムアウトになりました",
    "map_default_error_message": "現在位置が取得できませんでした",
    "new_place_title": "予定追加",
    "genre_label": "カテゴリー",
    "destination_label": "目的地",
    "add": "追加する",
    "save": "保存する",
    "title_label": "タイトル",
    "require_station": "駅名を入力してください",
    "change_residence_time": "時間変更",
    "arrival_time": "開始時刻",
    "arr_time": "チェックイン",
    "dep_time": "チェックアウト",
    "setting": "設定する",
    "filter_title": "フィルタ",
    "genre_title": "ジャンル",
    "search_place": "このエリアを検索",
    "duration_label": "{label}から往復で約{duration}分",
    "duration_before_label": "前の予定",
    "duration_current_label": "今",
    "sendai_marugoto_pass_use": "仙台まるごとパスを使う / 購入する",
    "map_search_placeholder": "市内を検索",
    "genre_list_link": "ジャンル一覧",
    "system_error_message": "システムエラーが発生しました。",
    "not_found_route_message": "指定した予定に到着できる経路が見つかりませんでした。設定を変更するか、追加した予定を削除してください。",
    "not_found_my_plan_message": "現在予定しているプランはありません。<br />オリジナルの旅行プランを作成してわたしだけのHAWAIIをもっと楽しんじゃおう！",
    "delete_confirm_message": "削除してもよろしいでしょうか？",
    "copied_message": "コピーしました",
    "plan_label": "旅行プラン",
    "map_label": "マップ",
    "remove_label": "削除",
    "taxi_distance_1km": "1km以上の移動のみ",
    "taxi_distance_3km": "3km以上の移動のみ",
    "taxi_distance_none": "利用しない",
    "preferred_route_condition_free_pass": "フリーパス優先",
    "preferred_route_condition_ekispert": "早さ優先",
    "gunma_maas_title": "ググっとぐんMaaS EAST",
    "get_total_charge_description": "※運賃に指定席料金が含まれています",
    "get_use_taxi_description": "※上記金額にタクシー代は含まれません",
    "present_location": "現在地",
    "demachiyanagi_station": "出町柳駅",
    "find_route": "経路を検索する",
    "reserve_hotel": "ホテルを予約する"
  },
  "en": {
    "main_title": "Travel Planning Services",
    "main_description": "It's easy to plan a trip based on recommended attractions and more.\nAdd or delete a destination, it automatically re-searches the way to get around, making it very easy to change your plans.",
    "sub_description1": "This service is available until November 30th, 2020.",
    "sub_description2": "Please be sure to check with each facility and store for further details.",
    "my_plan_section_title": "My Plan",
    "model_cource_title": "Create a Travel plan from a model/ recommended course",
    "display_detail_label": "View details",
    "create_plan_label": "Create an Travel plan",
    "category_title": "Create a Travel plan from category A",
    "faq_label": "Travel plan FAQ",
    "tohoku_maas_link": "TOHOKU MaaS TOP",
    "disclaimer_description1": "This service does not guarantee the itinerary of the searches displayed.",
    "disclaimer_description2": "Please use this service at your own risk.",
    "copyright": "Copyright ©East Japan Railway Company All Rights Reserved.",
    "plan_create_title": "Create a Travel plan",
    "departure_date_condition": "Departure date",
    "departure_datetime_condition": "Start time of the first appointment",
    "detail_conditions": "Detailed settings",
    "preferred_route_condition": "Preferred route",
    "taxi_condition": "Use taxi",
    "set_conditions_label": "Set up with these conditions",
    "departure_label": "Departure point",
    "change_departure_label": "Change departure point",
    "arrival_label": "Arrival point",
    "change_arrival_label": "Change departure point",
    "route_label": "Route",
    "minute_label": "Minute",
    "hour_label": "Hour (hours and minutes)",
    "residence_time_label": "Length of stay",
    "edit_label": "Edit",
    "add_destination_label": "Add a destination",
    "add_destination_from_map": "Add from map",
    "add_destination_from_category": "Add from category",
    "add_destination_from_favorite": "Add from favorites",
    "departure_time_label": "Departure",
    "arrival_time_label": "Arrival",
    "normal_fare": "Regular fee",
    "freepass_detail": "※ Two days of unlimited rides on eligible sections",
    "other_fare": "Fare other than the travel free pass",
    "fare": "Fare",
    "freepass_merit": "Save ￥{price} yen with a travel free pass",
    "freepass_link": "Click here for more information on the travel free pass",
    "save_label": "Save your plan",
    "back_to_plan_top_label": "Travel plan TOP",
    "save_success": "saved",
    "buy_ticket": "Click here if you want to purchase tickets in advance",
    "change_label": "Change plan ",
    "delete_label": "Delete plan ",
    "cory_share_url": "Copy URL to share",
    "send_mail": "Send by email",
    "send_line": "Send by LINE",
    "search_placeholder": "Search the city of Kyoto",
    "seach_this_area": "Search this area",
    "filter": "Filter ",
    "genre_all": "All genres",
    "genre": "Genre",
    "back": "Go back",
    "round_trip": "◯◯ minutes round trip from now",
    "shop_information": "Store information",
    "docomo_share_bike": "Docomo share bike",
    "tolocca": "To Locca",
    "docomo_ai_bus": "Akiu Ondemand Bus",
    "times_carshare": "Time's carshare",
    "location": "Location",
    "tel": "Phone number",
    "holoday": "Scheduled holiday",
    "website": "Official website",
    "business_hours": "Business hours",
    "nearest_station": "Nearest station",
    "search_route": "Search for a route",
    "add_to_plan": "Add to Travel plan",
    "locker_name": "Locker Name",
    "amount": "Amount of money",
    "space_availability": "Information on space availability",
    "by_size": "By size",
    "returnable_number": "Number of possible returns units",
    "avaliable_number": "Number of available units",
    "business_start_time": "Opening hours",
    "business_end_time": "Closing time",
    "appearance": "Appearance",
    "basic_charge": "Basic charge",
    "basic_usage_period": "Basic usage period",
    "extension_charge": "Extension charge",
    "extension_billing_unit_time": "Extended billing hours",
    "car_model": "Vehicle model",
    "available_number_of_people": "Number of persons",
    "area_name": "Service area name",
    "max_number_of_passenger": "Maximum number of passengers",
    "faq": "FAQ",
    "port_name": "Port name",
    "description": "Description",
    "about_label": "About",
    "price_with_currency_unit": null,
    "require_login": null,
    "not_found_plan": null,
    "course_label": null,
    "plan_link": null,
    "back_to_top": null,
    "setting_departure_label": null,
    "setting_arrival_label": null,
    "cancel": null,
    "change_arrival_time_and_residence_time": null,
    "change_arrival_time_and_departure_time": null,
    "remove_destination": null,
    "map_location_error_message": null,
    "map_permission_denied_error_message": null,
    "map_position_unavailable_error_message": null,
    "map_timeout_error_message": null,
    "map_default_error_message": null,
    "new_place_title": null,
    "genre_label": null,
    "destination_label": null,
    "add": null,
    "save": null,
    "title_label": null,
    "require_station": null,
    "change_residence_time": null,
    "arrival_time": null,
    "arr_time": null,
    "dep_time": null,
    "setting": null,
    "filter_title": null,
    "genre_title": null,
    "search_place": null,
    "duration_label": null,
    "duration_before_label": null,
    "duration_current_label": null,
    "sendai_marugoto_pass_use": null,
    "map_search_placeholder": null,
    "genre_list_link": null,
    "system_error_message": null,
    "not_found_route_message": null,
    "not_found_my_plan_message": "You must be logged in to create a trip plan. <br/>Create your own travel itinerary and enjoy your trip to Hawaii.",
    "delete_confirm_message": null,
    "copied_message": null,
    "plan_label": null,
    "map_label": null,
    "remove_label": null,
    "taxi_distance_1km": null,
    "taxi_distance_3km": null,
    "taxi_distance_none": null,
    "preferred_route_condition_free_pass": null,
    "preferred_route_condition_ekispert": null,
    "gunma_maas_title": null,
    "get_total_charge_description": null,
    "get_use_taxi_description": null,
    "present_location": "Your present location",
    "demachiyanagi_station": "Demachiyanagi Station",
    "find_route": "Search for a route",
    "reserve_hotel": "Reserver hotel"
  },
  "zh-TW": {
    "main_title": "行程規劃服務",
    "main_description": "可挑選推薦觀光景點來輕鬆排出旅遊行程。追加或刪除目的地後都會自動再次搜尋交通方式，可簡單變更行程計畫。",
    "sub_description1": "可使用至2021年1月31日。",
    "sub_description2": "各設施・店鋪的營業資訊，請自行確認。",
    "my_plan_section_title": "我的旅程",
    "model_cource_title": "用範例行程來規劃行程",
    "display_detail_label": "顯示詳情",
    "create_plan_label": "規劃行程",
    "category_title": "由category A 來規劃行程",
    "faq_label": "行程規劃常見問題",
    "tohoku_maas_link": "TOHOKU MaaS首頁",
    "disclaimer_description1": "本服務無法保證使用結果及搜尋、顯示出的行程_容。",
    "disclaimer_description2": "使用本服務時請自行負責。",
    "copyright": "東日本旅客鐵路株式會社",
    "plan_create_title": "規劃行程",
    "departure_date_condition": "出發日",
    "departure_datetime_condition": "第一次約會的開始時間",
    "detail_conditions": "詳細設定",
    "preferred_route_condition": "優先路線",
    "taxi_condition": "搭乘計程車",
    "set_conditions_label": "以此條件設定",
    "departure_label": "出發地點",
    "change_departure_label": "變更出發地點",
    "arrival_label": "抵達地點",
    "change_arrival_label": "變更出發地點",
    "route_label": "路線",
    "minute_label": "分",
    "hour_label": "時（時分）",
    "residence_time_label": "停留時間",
    "edit_label": "編輯",
    "add_destination_label": "追加目的地",
    "add_destination_from_map": "從地圖追加",
    "add_destination_from_category": "從分類追加",
    "add_destination_from_favorite": "從喜爱追加",
    "departure_time_label": "出發",
    "arrival_time_label": "抵達",
    "normal_fare": "一般費用",
    "freepass_detail": "※ 2天_可於適用範圍_任意搭乘",
    "other_fare": "周遊券以外車資",
    "fare": "車資",
    "freepass_merit": "使用週遊券可省{price}日圓",
    "freepass_link": "週遊券詳情請見此",
    "save_label": "儲存行程",
    "back_to_plan_top_label": "行程規劃首頁",
    "save_success": "已儲存",
    "buy_ticket": "欲事先購票者請見此",
    "change_label": "變更行程",
    "delete_label": "刪除行程",
    "cory_share_url": "複製分享連結",
    "send_mail": "用電子郵件傳送",
    "send_line": "用LINE傳送",
    "search_placeholder": "搜尋京都_",
    "seach_this_area": "搜尋此區域",
    "filter": "篩選",
    "genre_all": "所有分類",
    "genre": "分類",
    "back": "返回",
    "round_trip": "現在起往返OO分",
    "shop_information": "店家資訊",
    "docomo_share_bike": null,
    "tolocca": null,
    "docomo_ai_bus": null,
    "times_carshare": null,
    "location": "所在地",
    "tel": "電話號碼",
    "holoday": "公休日",
    "website": "官網",
    "business_hours": "營業時間",
    "nearest_station": "最近車站",
    "search_route": "搜尋路線",
    "add_to_plan": "追加至行程_",
    "locker_name": "置物櫃名稱",
    "amount": "金額",
    "space_availability": "空位_況",
    "by_size": "尺寸別",
    "returnable_number": "可還車台數",
    "avaliable_number": "可使用台數",
    "business_start_time": "營業開始時間",
    "business_end_time": "營業結束時間",
    "appearance": "外觀",
    "basic_charge": "基本費用",
    "basic_usage_period": "基本使用期間",
    "extension_charge": "延長費用",
    "extension_billing_unit_time": "延長收費計時單位",
    "car_model": "車種",
    "available_number_of_people": "可使用人數",
    "area_name": "提供區域名稱",
    "max_number_of_passenger": "最多乘車人數",
    "faq": "常見問題",
    "port_name": "租借站名稱",
    "description": "_明",
    "about_label": "約",
    "price_with_currency_unit": null,
    "require_login": null,
    "not_found_plan": null,
    "course_label": null,
    "plan_link": null,
    "back_to_top": null,
    "setting_departure_label": null,
    "setting_arrival_label": null,
    "cancel": null,
    "change_arrival_time_and_residence_time": null,
    "change_arrival_time_and_departure_time": null,
    "remove_destination": null,
    "map_location_error_message": null,
    "map_permission_denied_error_message": null,
    "map_position_unavailable_error_message": null,
    "map_timeout_error_message": null,
    "map_default_error_message": null,
    "new_place_title": null,
    "genre_label": null,
    "destination_label": null,
    "add": null,
    "save": null,
    "title_label": null,
    "require_station": null,
    "change_residence_time": null,
    "arrival_time": null,
    "arr_time": null,
    "dep_time": null,
    "setting": null,
    "filter_title": null,
    "genre_title": null,
    "search_place": null,
    "duration_label": null,
    "duration_before_label": null,
    "duration_current_label": null,
    "sendai_marugoto_pass_use": null,
    "map_search_placeholder": null,
    "genre_list_link": null,
    "system_error_message": null,
    "not_found_route_message": null,
    "not_found_my_plan_message": "您需要登錄才能創建旅行計劃。<br />制定旅行計劃，享受前往HAWAII的旅行",
    "delete_confirm_message": null,
    "copied_message": null,
    "plan_label": null,
    "map_label": null,
    "remove_label": null,
    "taxi_distance_1km": null,
    "taxi_distance_3km": null,
    "taxi_distance_none": null,
    "preferred_route_condition_free_pass": null,
    "preferred_route_condition_ekispert": null,
    "gunma_maas_title": null,
    "get_total_charge_description": null,
    "get_use_taxi_description": null,
    "present_location": "現在位置",
    "demachiyanagi_station": "出町柳駅",
    "find_route": "搜索路線",
    "reserve_hotel": "預定旅館"
  }
}

export default locales
